import React from 'react';
// import { useTranslation } from 'react-i18next';
import {
  Box,
  COLORS,
  Flex,
  Grid,
  Typography,
  useTheme,
} from '@dripcapital/dripui-v1';
import { saveAs } from 'file-saver';
import { File } from 'api';
import { DAJ_COLORS } from 'utils';
import { AtomicButton } from 'atoms';
import { ButtonTypeEnum } from 'enums';
import Download from '@mui/icons-material/Download';
import FolderOpen from '@mui/icons-material/FolderOpen';

type Props = {
  statements: File[];
  renderTrailing?: (file: File) => React.ReactNode;
  dataTestIdPrefix?: string;
};

const FileList: React.FC<Props> = ({
  statements,
  renderTrailing,
  dataTestIdPrefix = 'file-list',
}: Props) => {
  // const { t } = useTranslation();

  const { spacing } = useTheme();

  const download = (upload: File) => {
    saveAs(upload?.url || '', upload?.name || '');
  };

  if (!Array.isArray(statements) || statements?.length == 0) {
    return null;
  }

  return (
    <Grid
      dataTestId={`${dataTestIdPrefix}-container`}
      container
      rowSpacing={2}
      _sx={{ width: '100%' }}
    >
      {statements.map((file, index) => {
        return (
          <Grid dataTestId={`${dataTestIdPrefix}-row`} key={index} item xs={12}>
            <Box
              _sx={{
                borderColor: DAJ_COLORS.LIGHT_GRAY,
                borderWidth: 1,
                borderStyle: 'solid',
                borderRadius: 2,
              }}
            >
              <Flex
                direction="row"
                alignItems="center"
                _sx={{
                  justifyContent: 'space-between',
                  paddingX: 2,
                  paddingY: 1,
                }}
              >
                <Flex alignItems="center" _sx={{ width: '60%', minWidth: 0 }}>
                  <FolderOpen
                    sx={{ marginRight: 1, color: COLORS.SECONDARY }}
                  />
                  <Typography variant="body" title={file?.name || ''} noWrap>
                    {file.name}
                  </Typography>
                  {renderTrailing ? (
                    <Box _sx={{ marginLeft: 1 }}>{renderTrailing(file)}</Box>
                  ) : null}
                </Flex>
                <Flex alignItems="center" justifyContent="flex-end">
                  <AtomicButton
                    dataTestId={`${dataTestIdPrefix}-download`}
                    variant={ButtonTypeEnum.TEXT}
                    _sx={{
                      fontSize: spacing(2),
                      padding: 0.4,
                      color: COLORS.PRIMARY,
                      '.MuiIcon': {
                        marginLeft: 1,
                        color: COLORS.PRIMARY,
                      },
                    }}
                    startIcon={Download}
                    onClick={() => download(file)}
                  >
                    {/* {t('btn_download')} */}
                  </AtomicButton>
                </Flex>
              </Flex>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default FileList;
